import { Component, OnInit, Input } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import {MobilePivotModel} from './mobile-pivot.model';
@Component({
  selector: 'app-mobile-pivot',
  templateUrl: './mobile-pivot.component.html',
  styleUrls: ['./mobile-pivot.component.scss']
})
export class MobilePivotComponent implements OnInit {

   @Input('pivots') pivot: Array<MobilePivotModel>;

  constructor() { }

  ngOnInit() {
    
  }

}
